import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const joinWaitlist = (data) => {
  // Automatically attach the visitor's preferred UI language so the Signal
  // Room digest can address them in their own tongue.
  const lang = (() => {
    try { return localStorage.getItem("ix.lang") || null; } catch (_) { return null; }
  })();
  return api.post("/waitlist", { ...data, preferred_lang: lang || undefined }).then((r) => r.data);
};
export const getWaitlistCount = () => api.get("/waitlist/count").then((r) => r.data);
export const sendContact = (data) => api.post("/contact", data).then((r) => r.data);
export const getRates = () => api.get("/rates").then((r) => r.data);
export const founderLookup = (email) => api.post("/founders/lookup", { email }).then((r) => r.data);
export const checkHandle = (handle) =>
  api.get("/founders/handle-available", { params: { handle } }).then((r) => r.data);
export const reserveHandle = (email, handle) =>
  api.post("/founders/reserve-handle", { email, handle }).then((r) => r.data);
export const getLeaderboard = (limit = 10) =>
  api.get("/founders/leaderboard", { params: { limit } }).then((r) => r.data);
export const getPublicHandle = (handle) =>
  api.get(`/founders/handle/${encodeURIComponent(handle)}`).then((r) => r.data);
export const shareUrlFor = (code) => `${API}/share/${code}`;
export const setTestimonial = (email, testimonial) =>
  api.post("/founders/testimonial", { email, testimonial }).then((r) => r.data);
export const getCorridorStats = () => api.get("/founders/corridor-stats").then((r) => r.data);
